import React, {useState, useEffect} from 'react';
import Main from './Main';
import Axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faUser, faCircle, faEdit,faPlusSquare } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Loading from '../componentes/Loading';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import {
    Spinner, Typography,Button,Badge
} from "@material-tailwind/react";
export default function Logs({finalizarSeleccion}){

    const [buscando,setBuscando]=useState(false)
    const [huboError,setHuboError]=useState(false)
    const [logs,setLogs]=useState([]);


    useEffect(()=>{
       
        buscarLogs()
    },[])

     const buscarLogs = async ()=>{
        setBuscando(true)
        try{
             const {data}= await Axios.get('/api/tablasgenerales/logs')
     
             setLogs(data.documentos)
             setBuscando(false)
         }catch(err){
             console.log(err.response.data)
             setBuscando(false)
             setHuboError(true)
         }
     }     

    const abrirArchivo = async (nombre) => {

    /* ¿Por qué este flujo? Por cuestiones de seguridad ahora la carpeta /logs no está accesible entonces no se pueden descargar directamente archivos desde el navegador
    1. Necesitamos enviar el JWT (Axios) para que el backend autorice la descarga.
    2. El navegador recibe los datos en RAM (Blob) pero no sabe "guardarlos" solos.
    3. Creamos una URL temporal y un link invisible para forzar la descarga al disco.
    */

        try {
            // 1. PETICIÓN AL BACKEND
            const response = await Axios.get(
                `/api/tablasgenerales/logs/descargar/${nombre}`, 
                { responseType: 'blob' }                      // Indica a Axios que reciba datos binarios, no JSON
            );

            // 2. PROCESAMIENTO EN MEMORIA RAM
            const blob = new Blob([response.data]);           // Convierte los datos crudos en un objeto de archivo JS
            const url = window.URL.createObjectURL(blob);     // Crea una ruta temporal (link) que apunta a esa RAM

            // 3. SIMULACIÓN DE DESCARGA EN EL NAVEGADOR
            const a = document.createElement('a');            // Crea un elemento <a> que nunca se verá en pantalla
            a.href = url;                                     // Le asigna la ruta temporal como destino
            a.download = nombre;                              // Fuerza al navegador a descargar en vez de navegar
            document.body.appendChild(a);                     // Lo inserta al DOM un segundo para que sea "clickeable"
            a.click();                                        // Dispara la descarga automáticamente

            // 4. LIMPIEZA (IMPORTANTE PARA EL RENDIMIENTO)
            a.remove();                                       // Elimina el link invisible del HTML
            window.URL.revokeObjectURL(url);                  // Libera la memoria RAM liberando la URL temporal

        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'No se pudo descargar el archivo',
                text: err.message                             // Muestra el error real si falla la red o el permiso
            });
        }
    };     

    if (huboError){
        return <Main center><span>Se produjo un error al cargar los datos para esta vista</span></Main>
    }

    if (buscando){
        return <Main center><div><Loading/><span className="cargando">Buscando logs...</span></div></Main>
    };

    if(logs.length>0){
        return (<Main center>
            <Typography
                variant="small"
                color="gray"
                className="flex items-center justify-center gap-2 font-semibold text-black text-[20px] mb-4 mt-4"
            >
                Estos archivos ahora se descargan de manera segura con un usuario autenticado            
            </Typography>            
            <div className="flex justify-center p-2 mt-4">
                    {logs.length > 0 && <>
                        <table>
                            <tbody>
                                {logs.map(item=><tr className="h-16">
                                      <td>
                                        <button
                                        onClick={()=>abrirArchivo(item.nombre)}
                                        >
                                        {item.nombre} 
                                        </button>
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>
                    </>}
            </div>
            </Main>
        )
    }else{
        return <h1>No hay archivos</h1>
    }
}

